// extracted by css-extract-rspack-plugin
export default {"header":"header_nM7ji","headerMenu":"header-menu_wWhPT","reorderIcon":"reorder-icon_zUUHi","toolsItem":"tools-item_ISsbr","avatar":"avatar_QVC36","headerText":"header-text_Xw5xL"};